export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/Square/theme/components/scorecard/MetricsLabels/index.js